import React from 'react';
import { Box } from '@mui/material';
import Apex from './Apex';

const ApexSettings = ({ defaultSettings, onUpdateSettings }) => {
  return (
    <Box sx={{ mt: 4 }}>
      {defaultSettings?.apex && (
        <Apex
          settings={defaultSettings.apex}
          onUpdateSettings={onUpdateSettings}
        />
      )}
    </Box>
  );
};

export default ApexSettings;
